import { Observable } from 'rxjs';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { BaseDao } from './BaseDao';

export interface IAmazonCampaignModel {
  campaignId: number;
  campaignType: string;
  dailyBudget: number;
  name: string;
  premiumBidAdjustment: boolean;
  startDate: string;
  state: string;
  targetingType: string;
}

export interface IAmazonAdGroupModel {
  adGroupId: number;
  campaignId: number;
  name: string;
  defaultBid: number;
  state: string;
}

export interface IAmazonKeywordModel {
  keywordId: number;
  campaignId: number;
  adGroupId: number;
  state: string;
  keywordText: string;
  matchType: string;
  bid: number;
}

export class AmazonActionDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.AMAZONACTION, apiHelper);
  }

  public loadCampaigns(integrationId: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/campaigns?integrationId=' + integrationId;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(url, 'GET', null, null, headers, null);
  }

  public loadAdGroups(integrationId: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/adGroups?integrationId=' + integrationId;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers, null);
  }

}
